import React from "react";
import { Routes, Route } from "react-router-dom";

import ThemeControls from "../Component/AllThemesControl";

import MoudleRoutes from "./Routes.js";

function MainSection() {
  const { useStyles } = ThemeControls;
  const classes = useStyles();

  return (
    <div className={classes.MainSection}>
      <MoudleRoutes/>
    </div>
  );
}
export default MainSection;
